module.exports = __webpack_public_path__ + "img/8.18696d4c.png";